import { FC } from 'react'
import { Typography, Badge, Row, Col, Icon } from '@repo/ui/components'
import { useTranslate } from '@repo/shared/hooks'
import { LevelsBadge, ValueWithUnit } from '@repo/shared/components'
import Image from 'next/image'
import { UserReferralStats } from '@repo/services'

export const InviteDetails: FC<{
  item: UserReferralStats
  showTrades?: boolean
}> = ({ item, showTrades = true }) => {
  const { t } = useTranslate()

  return (
    <div className=' flex flex-col  items-center    w-full   '>
      <Row>
        <Col className='gap-2xs items-center'>
          <Typography size='xs' color='text-neutral-surface-60'>
            {t('inviteTable_header_kyc_level')}
          </Typography>
          {item.kyc ? (
            <LevelsBadge noNumber level={(item.userLevel ?? 0) + 1} />
          ) : (
            <Badge
              color={'alert'}
              size='sm'
              variant='custom'
              className='text-alert-surface-100'
            >
              {t('inviteTable_label_kyc_pending')}
            </Badge>
          )}
        </Col>
        <Col className='gap-2xs items-center'>
          <Typography size='xs' color='text-neutral-surface-60'>
            {t('inviteTable_header_subCount')}
          </Typography>
          <Row className='gap-sm items-center w-fit'>
            <Typography
              size='xs'
              weight='bold'
              color='text-neutral-surface-100'
            >
              {t('inviteTable_header_subCount_direct')}:
              {item.directInvites || '0'}
            </Typography>

            <Typography
              size='xs'
              weight='bold'
              color='text-neutral-surface-100'
            >
              {t('inviteTable_header_subCount_all')}:{' '}
              {item.totalInvites || 0}{' '}
            </Typography>
          </Row>
        </Col>

        {showTrades && (
          <Col className='gap-2xs items-center'>
            <Typography size='xs' color='text-neutral-surface-60'>
              {t('inviteTable_header_tradeCount')}
            </Typography>

            {item.trades ? (
              <Typography
                size='xs'
                weight='bold'
                color='text-neutral-surface-100'
              >
                {item.trades}
              </Typography>
            ) : (
              <Badge
                color={'alert'}
                size='sm'
                variant='custom'
                className='text-alert-surface-100 gap-2xs flex items-center'
              >
                <Icon
                  color='fill-alert-main'
                  name='AlertTriangle'
                  className='w-4 h-4'
                />{' '}
                {t('inviteTable_label_tradeCount_none')}
              </Badge>
            )}
          </Col>
        )}
      </Row>

      <div className=' w-full px-sm py-xs whitespace-nowrap rtl:text-left ltr:text-right mt-md '>
        <div className='flex flex-row justify-between   gap-xs '>
          <Typography
            size='xs'
            color='text-neutral-surface-60'
            className='px-sm'
          >
            {t('inviteTable_header_directEarned')}
          </Typography>
          <Row className='justify-end w-full   items-center gap-xs '>
            <Typography size='xs' color='text-neutral-surface-100'>
              <ValueWithUnit
                showZero={false}
                value={item.totalDirectEarned || 0}
                valueSize='xs'
                unitSize='sm'
                valueWeight='regular'
              />
            </Typography>

            <Image
              src='/images/club-gem.svg'
              alt='coin'
              width={20}
              height={20}
            />
          </Row>
        </div>
      </div>

      <div className=' w-full px-sm pt-xs pb-sm whitespace-nowrap rtl:text-left ltr:text-right '>
        <div className='flex flex-row justify-between   gap-xs '>
          <Typography
            size='xs'
            color='text-neutral-surface-60'
            className='px-sm'
          >
            {t('inviteTable_header_subEarned')}
          </Typography>
          <Row className='justify-end w-full   items-center gap-xs '>
            <Typography size='xs' color='text-neutral-surface-100'>
              <ValueWithUnit
                showZero={false}
                value={item.totalIndirectEarned || 0}
                valueSize='xs'
                unitSize='sm'
                valueWeight='regular'
              />
            </Typography>

            <Image
              src='/images/club-gem.svg'
              alt='coin'
              width={20}
              height={20}
            />
          </Row>
        </div>
      </div>
      <Row className=' p-md bg-neutral-surface rounded-md  items-center justify-between mb-md'>
        <Typography size='md'>{t('inviteTable_header_totalEarned')}</Typography>
        <Row className='justify-end w-fit   items-center gap-xs '>
          <Typography size='sm' color='text-neutral-surface-100'>
            <ValueWithUnit
              showZero={false}
              value={item.totalEarned || 0}
              valueSize='sm'
              unitSize='2xs'
              valueWeight='bold'
            />
          </Typography>

          <Image src='/images/club-gem.svg' alt='coin' width={20} height={20} />
        </Row>
      </Row>
    </div>
  )
}
